import React from 'react';
import styled from 'styled-components';
import {getOptImage} from 'epic-ue-shared';

export interface BgImageProps {
    img?: string;
    width?: number;
    bgPosY?: 'top' | 'bottom' | 'center' | 'inherit' | 'initial' | 'unset';
    children?: React.ReactNode;
}

const Image = styled.div<BgImageProps>`
    background: url(${(p) => getOptImage({url: p.img || '', width: p.width})});
    background-repeat: no-repeat;
    background-position: center ${(p) => p.bgPosY || 'center'};
    background-size: cover;
`;

export const BgImage = ({img, width, children, bgPosY}: BgImageProps): JSX.Element => {
    return (
        <Image img={img} width={width} bgPosY={bgPosY} className="background-image">
            {children}
        </Image>
    );
};
